import { useEffect, type ComponentType } from "react";
import { ToggleButton } from "./drawer";

export const withWithoutApplicationSettings = <TProps extends object>(Component: ComponentType<TProps>) =>
    (props: TProps) => {
        useEffect(() => {
            const applicationSettings = document.getElementById(ToggleButton.id);
            if (applicationSettings) {
                applicationSettings.style.display = 'none';
            }
        }, []);

        return (
            <Component
                {...props}
            />
        );
    };